import React, { useLayoutEffect, useRef } from 'react';
import { TextInput, TextInputPropsWithType } from '@volkswagen-onehub/components-core';

type NoTranslateTextInputProps = TextInputPropsWithType & {
  selectors?: string[];
};

export const NoTranslateTextInput = React.forwardRef<HTMLInputElement, NoTranslateTextInputProps>(
  (props, ref) => {
    const { selectors = ['input'], ...textInputProps } = props;
    const wrapperRef = useRef<HTMLDivElement>(null);
    
    useLayoutEffect(() => {
      if (wrapperRef.current) {
        selectors.forEach(selector => {
          const elements = wrapperRef.current?.querySelectorAll(selector);
          elements?.forEach(element => {
            element.classList.add('notranslate');
          });
        });
      }
    }, []);
    
    return (
      <div ref={wrapperRef}>
        <TextInput {...textInputProps} ref={ref} />
      </div>
    );
  }
);